/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPolicyBypassRequestsCreate } from "../funcs/riskPolicyBypassRequestsCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { PolicyBypassRedemption } from "../models/components/policybypassredemption.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateRiskPolicyBypassRequestRequest,
  CreateRiskPolicyBypassRequestSecurity,
} from "../models/operations/createriskpolicybypassrequest.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type RiskCreatePolicyBypassRequestMutationVariables = {
  request: CreateRiskPolicyBypassRequestRequest;
  security?: CreateRiskPolicyBypassRequestSecurity | undefined;
  options?: RequestOptions;
};

export type RiskCreatePolicyBypassRequestMutationData = PolicyBypassRedemption;

export type RiskCreatePolicyBypassRequestMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createRiskPolicyBypassRequest risk
 *
 * @remarks
 * Create or refresh a risk policy bypass request from a signed request URL token.
 */
export function useRiskCreatePolicyBypassRequestMutation(
  options?: MutationHookOptions<
    RiskCreatePolicyBypassRequestMutationData,
    RiskCreatePolicyBypassRequestMutationError,
    RiskCreatePolicyBypassRequestMutationVariables
  >,
): UseMutationResult<
  RiskCreatePolicyBypassRequestMutationData,
  RiskCreatePolicyBypassRequestMutationError,
  RiskCreatePolicyBypassRequestMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildRiskCreatePolicyBypassRequestMutation(client, options),
    ...options,
  });
}

export function mutationKeyRiskCreatePolicyBypassRequest(): MutationKey {
  return ["@gram/client", "policyBypassRequests", "create"];
}

export function buildRiskCreatePolicyBypassRequestMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: RiskCreatePolicyBypassRequestMutationVariables,
  ) => Promise<RiskCreatePolicyBypassRequestMutationData>;
} {
  return {
    mutationKey: mutationKeyRiskCreatePolicyBypassRequest(),
    mutationFn: function riskCreatePolicyBypassRequestMutationFn({
      request,
      security,
      options,
    }): Promise<RiskCreatePolicyBypassRequestMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(riskPolicyBypassRequestsCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
